import { requestStatusOptions } from "../../../constants";

export const getRequestByStatus = (
  requests: Array<any>,
  status: Array<string>
) => {
  return requests.filter((req) => status.includes(req.fields.eRequestStatus));
};

export const getLabelRequestStatus = (status: string, isDemand: boolean) => requestStatusOptions